export default "__VITE_ASSET__DOUGZ6G9__"